import { render, staticRenderFns } from "./ProductionAnalysis.vue?vue&type=template&id=66d6f983&scoped=true"
import script from "./ProductionAnalysis.vue?vue&type=script&lang=js"
export * from "./ProductionAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProductionAnalysis.vue?vue&type=style&index=0&id=66d6f983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d6f983",
  null
  
)

export default component.exports